import { t } from "i18next";

export const getTemplateMessages = () => {
  const path = "oceanWeatherIntelligence.insightAlert";
  return {
    extreme_wind: {
      title: t(`${path}.extremeWindTitle`),
      description: t(`${path}.possibilityOfImpacts`),
    },
    port_closure: {
      title: t(`${path}.portClosureTitle`),
      description: t(`${path}.potentialSuspension`),
    },
    extreme_rain: {
      title: t(`${path}.extreme_rain`),
      description: t(`${path}.possibilityOfFlooding`),
    },
  } as Record<string, { title: string; description: string }>;
};
